const MuiStepButton = {
  styleOverrides: {
    root: {
      '&.default-cursor': {
        cursor: 'default',
      },
    },
  },
};

export default MuiStepButton;
